<div class="modus-layout">
  <div class="modus-content-rows">
    <div class="h-100">
      <div class="bg-panel-background d-flex align-items-center fullHeight">
        <div class="ml-auto mr-auto">
          <div class="card shadow-1">
            <div class="card-body">
              <div class="text-center p-3">
                <div class="spinner-border"></div>
                <div class="h3 text-primary mt-3 mb-0">Logging In...</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
